module.exports = __webpack_public_path__ + "static/media/add-icon-hover-af.e89d8c00.svg";